module.exports = __webpack_public_path__ + "static/media/new-york-city.6d16383a.svg";